const hex = x => x.toString(16).length === 1 ? "0" + x.toString(16) : x.toString(16),
  getR = c => parseInt(c.substring(1, 3), 16),
  getG = c => parseInt(c.substring(3, 5), 16),
  getB = c => parseInt(c.substring(5), 16),
  getRGB = hex2 => `rgb(${getR(hex2)}, ${getG(hex2)}, ${getB(hex2)})`,
  getRGBA = (hex2, opacity) => `rgba(${getR(hex2)}, ${getG(hex2)}, ${getB(hex2)}, ${opacity})`;
export { getB, getG, getR, getRGB, getRGBA, hex };